export default function printProductMovementRelation(filters) {
  const token = localStorage.getItem("token");
  const params = new URLSearchParams({
    auth: token,
    startDate: filters.startDate,
    endDate: filters.endDate,
    reportType: filters.reportType,
  });

  if (filters.idAgrotoxico) {
    params.set("idAgrotoxico", filters.idAgrotoxico);
  }

  if (filters.embalagem) {
    params.set("embalagem", filters.embalagem);
  }

  if (filters.tipo) {
    params.set("tipo", filters.tipo);
  }

  if (filters.destinoProduto) {
    params.set("destinoProduto", filters.destinoProduto);
  }

  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/moviment-agrotoxico/print/product-movement?${params.toString()}`
  );
}
